module.exports = __webpack_public_path__ + "static/media/olivebranch_white.23736f0a.webp";